<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="75"
  >
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click=" setDrawer(!drawer) "
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name " 
    />
   <v-spacer />
    <div class="mx-3" />
      <v-chip
        v-text="$store.state.usuario.nombre " 
      >
      </v-chip>
    <v-spacer />
    <div class="mx-3" />
    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
          
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        flat
        nav
      >
        <template v-for="(p, i) in profile">
          <v-divider
            v-if="p.divider"
            :key="`divider-${i}`"
            class="mb-2 mt-2"
          />

          <app-bar-item
            v-else
            :key="`item-${i}`"
            to="/"
          >
            <v-list-item-title v-text="p.title" />
          </app-bar-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>


<script>
   // Components
  import { VHover, VListItem } from 'vuetify/lib'
  import axios from "axios";
  // Utilities
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
    
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
      
    },
    

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
    
      profile: [
        //{ title: 'Profile' },
        //{ title: 'Settings' },
      
        { title: 'Log out'},
      ],
    }),

    computed: {
      ...mapState(['drawer']),
        logueado() {
      if(localStorage.getItem("unico")){
         this.mainMenuByUser();
      }
     
      return this.$store.state.usuario;
    },
    esAdministrador() {
      return (
        this.$store.state.usuario && this.$store.state.usuario.rol == "admin"
      );
    },
    esUser() {
      return (
        this.$store.state.usuario && this.$store.state.usuario.rol == "user"
      );
    }
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),

      mainMenuByUser() {
      this.items=[];
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      console.log("ingrese mainimenubyuser",configuracion);
       console.log("Unico : ",localStorage.getItem("unico"));
        axios
            .get("api/Users/mainMenuByUser/"+localStorage.getItem("unico"),configuracion)
            .then(function(response) {
                console.log("depsues de axios mainMenuByUser");
                me.items = response.data;
                console.log( me.items);
            })
            .catch(function(error) {
            console.log(error);
            });
      },

      salir() {
        this.$store.dispatch("salir");
      }
    
    },
  }
</script>
